import type { GetAllAgentsDetailsProjection } from '@urbanx/agx.agencies.client';
import { AgxAvatarLabelGroup, AgxSpacer } from '@urbanx/agx.ui-components2';

const LeadAgentCell = ({
  id,
  agent,
  mode,
  truncateLabels,
}: {
  id: string;
  agent?: GetAllAgentsDetailsProjection;
  mode?: 'icon' | 'letters';
  truncateLabels?: boolean;
}) =>
  agent ? (
    <AgxSpacer contentAlignment="start">
      <AgxAvatarLabelGroup
        id={id}
        label1={agent.name?.fullName ?? '--'}
        photoUrl={agent.photoUri}
        type="avatar"
        variant="round"
        size="sm"
        mode={mode}
        truncateLabels={truncateLabels}
      />
    </AgxSpacer>
  ) : (
    '--'
  );

export default LeadAgentCell;
